"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("../../Typography"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const renderTypography = (value, themeTokens, ratePosition, fontColor) => {
  const customProps = ratePosition === 'bottom' && value !== '$' ? {
    variant: {
      size: 'micro'
    },
    tokens: {
      color: fontColor
    }
  } : {
    tokens: {
      ...themeTokens,
      color: fontColor
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
    ...customProps,
    children: value
  });
};
var _default = exports.default = renderTypography;